import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, HostListener, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewEncapsulation } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { SwitchComponent } from '@syncfusion/ej2-angular-buttons';
import { CheckBoxSelection, ListBox, ListBoxComponent } from '@syncfusion/ej2-angular-dropdowns';
import { DialogComponent } from '@syncfusion/ej2-angular-popups';
import { EmitType, getInstance } from '@syncfusion/ej2-base';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { DataScopesEnum } from '../../shared/enums/index';
import { AppGlobals } from '../../shared/globals/appGlobals';
import { fadeInOut } from '../../shared/helpers/animations';
import { IApiCredentials, IApiCredentialsSetting, ICustomer, ILanguageApiResponse, IPermission, IServerSettings, IServiceError } from '../../shared/models/index';
import { ILanguage, IApplicationSettings, IApplicationConfigData, ILanguageSupport } from '../../shared/models/app-settings.model';
import { ApiCredentialsService, AuthorizationService, CustomerService, SettingsService, StorageManagerService } from '../../shared/services/index';
import { GridComponent } from '@syncfusion/ej2-angular-grids';
import { timer } from 'rxjs';


ListBoxComponent.Inject(CheckBoxSelection);

@Component({
  selector: 'app-api-credentials',
  templateUrl: './api-credentials.component.html',
  styleUrls: ['./api-credentials.component.scss'],
  animations: [fadeInOut],
  encapsulation: ViewEncapsulation.Emulated,
  standalone: false
})
export class ApiCredentialsComponent implements OnInit, OnDestroy, AfterViewInit, AfterViewChecked {

  resolverData: any[] | IServiceError;
  apiData: IApiCredentials | IServiceError;
  sortedClientLanguageDataNames: ILanguageSupport[];
  applicationVariants: any[] = [];
  dataScopeEnum: any;
  customer: ICustomer;
  subscription: Subscription;
  accessPermissions: IPermission[] = [];
  permissionsPerClient = [];
  showLink = true;
  showEUDLink = true;
  apiSKForm: FormGroup;
  apiEUDForm: FormGroup;
  apiAUForm: FormGroup;
  apiSWForm: FormGroup;
  formSaved = false;
  isMatch = false;
  displayedText: string;
  // iconClass: string;
  dataScope: string;
  loading = false;
  saving = false;
  cancelledForm = false;
  apiCredentialsSettings: IApiCredentialsSetting[] = [];
  data: any;
  permissionsConst: any;
  clientData: any[] | IServiceError;
  toDelete = { appVarName: '', id: '' };
  showSKForm = false;
  showEUDForm = false;
  showAUForm = false;
  showSWForm = false;
  duplicateSNR = false;
  duplicateTBSID = false;
  duplicateCHRN = false;
  showEyeIcon = false;
  showEyeIconCompare = false;
  systemLanguages: any[];
  displayEditScreen = false;
  appConfigObject: IApplicationConfigData;
  languageData: IApplicationSettings;
  channelLanguageSupport: ILanguageSupport;
  channelLanguageEnabled = false;
  languagesListBoxDS: any[] = [];
  listBoxFields: Object;
  selectedLanguagesArray: any[] = [];
  selectedDisplayLanguageCode: string;
  formModified = false;
  clientLanguageSupportEnabled = false;
  allSSMDSystemLanguagesCategory = 146;
  eudamedLanguagesCategory = 147;
  swissdamedLanguagesCategory = 180;

  activeTab = 'clientAdmin';
  languageTabEnabled = false;
  clientAdminTabEnabled = false;
  languageAdminPermission = false;
  noChangesVodalVisible = false;

  srnPattern = '^(AF|AX|AL|DZ|AS|AD|AO|AI|AQ|AG|AR|AM|AW|AU|AT|AZ|BH|BS|BD|BB|BY|BE|BZ|BJ|BM|BT|BO|BQ|BA|BW|BV|BR|IO|BN|BG|BF|BI|KH|CM|CA|CV|KY|CF|TD|CL|CN|CX|CC|CO|KM|CG|CD|CK|CR|CI|HR|CU|CW|CY|CZ|DK|DJ|DM|DO|EC|EG|EL|SV|GQ|ER|EE|ET|FK|FO|FJ|FI|FR|GF|PF|TF|GA|GM|GE|DE|GH|GI|GR|GL|GD|GP|GU|GT|GG|GN|GW|GY|HT|HM|VA|HN|HK|HU|IS|IN|ID|IR|IQ|IE|IM|IL|IT|JM|JP|JE|JO|KZ|KE|KI|KP|KR|KW|KG|LA|LV|LB|LS|LR|LY|LI|LT|LU|MO|MK|MG|MW|MY|MV|ML|MT|MH|MQ|MR|MU|YT|MX|FM|MD|MC|MN|ME|MS|MA|MZ|MM|NA|NR|NP|NL|NC|NZ|NI|NE|NG|NU|NF|MP|NO|OM|PK|PW|PS|PA|PG|PY|PE|PH|PN|PL|PT|PR|QA|RE|RO|RU|RW|BL|SH|KN|LC|MF|PM|VC|WS|SM|ST|SA|SN|RS|SC|SL|SG|SX|SK|SI|SB|SO|ZA|GS|SS|ES|LK|SD|SR|SJ|SZ|SE|CH|SY|TW|TJ|TZ|TH|TL|TG|TK|TO|TT|TN|TR|TM|TC|TV|UG|UA|UK|AE|GB|US|UM|UY|UZ|VU|VE|VN|VG|VI|XI|WF|EH|YE|ZM|ZW)-(AR|MF|SP|IM|PR)-[0-9]{9}$';


  ddwFields: Object = { text: 'displayValue', value: 'code' };

  @ViewChild('tabset', { static: true })
  public tabset: NgbNav;

  @ViewChild('switch')
  public switch: SwitchComponent;

  @ViewChild('languageForm') form: any;

  @ViewChild('modalDialog')
  public modalDialog: DialogComponent;

  @ViewChild('grid')
  public grid: GridComponent;

  formErrors = {
    clientId: '',
    clientPassword: '',
    comparePassword: '',
    srn: '',
    accessToken: '',
    compareAccessToken: '',
    tbsid: '',
    subscriptionKey: '',
    compareSubscriptionKey: '',
    chrn: '',
    swClientId: '',
    swClientSecret: '',
    compareSwClientSecret: ''
  };

  validationMessages = {
    clientId: {
      required: 'Client Id is required'
    },
    clientPassword: {
      required: 'Client Secret (Password) is required'
    },
    comparePassword: {
      required: 'Compare password is required',
    },
    srn: {
      required: 'SRN is required',
      duplicate: 'SRN is not unique',
      pattern: 'Invalid SRN pattern'
    },
    accessToken: {
      required: 'Access Token is required',
    },
    compareAccessToken: {
      required: 'Compare Access Token is required',
    },
    tbsid: {
      required: 'TBS ID is required',
      duplicate: 'TBS ID is not unique',
      maxlength: 'TBS ID cannot exceed 250 characters'
    },
    subscriptionKey: {
      required: 'Subscription Key is required',
      maxlength: 'Subscription Key cannot exceed 250 characters'
    },
    compareSubscriptionKey: {
      required: 'Compare Subscription Key is required',
    },
    chrn: {
      required: 'CHRN is required',
      duplicate: 'The CHRN is already configured for the company site in this environment',
      maxlength: 'CHRN cannot exceed 250 characters'
    },
    swClientId: {
      required: 'Client ID is required',
      maxlength: 'Client ID cannot exceed 250 characters'
    },
    swClientSecret: {
      required: 'Client Secret is required',
      maxlength: 'Client Secret cannot exceed 250 characters'
    },
    compareSwClientSecret: {
      required: 'Confirm Client Secret is required',
    }
  };

  @ViewChild('confirmDialog', { static: true })
  public confirmDialog: DialogComponent;

  // dialog settings
  isModal = true;
  animationSettings: Object = { effect: 'Zoom' };
  hide: any;
  position: object = { X: 'center', Y: 'center' };
  visible = false;
  modalWidth = '450px';
  formatOptions: Object;
  listBoxSelection: Object;

  serverSettings: IServerSettings;
  timerInterval: any;

  confirmDlgBtnClickYes: EmitType<object> = () => {
    this.confirmDialog.hide();

    if (this.displayEditScreen) {

      // the parameter indicates that the confirmation was received
      this.saveLanguageEdit(true);
    } else {
      this.deleteApiCredentials();
    }
  }

  confirmDlgBtnClickNo: EmitType<object> = () => {

    this.confirmDialog.hide();
  }

  // tslint:disable-next-line:member-ordering
  confirmDlgButtons: Object[] = [{ click: this.confirmDlgBtnClickNo.bind(this), buttonModel: { content: 'Cancel', cssClass: 'dialogButton' } }, { click: this.confirmDlgBtnClickYes.bind(this), buttonModel: { content: 'Confirm', isPrimary: true, cssClass: 'dialogButton' } }];

  overlayClick = (): void => {
    this.modalDialog.hide();
  }

  dlgButtonClick = (): void => {
    this.modalDialog.hide();
    this.formModified = false;
  }

  buttons: Object[] = [{ click: this.dlgButtonClick.bind(this), buttonModel: { content: 'OK', isPrimary: true } }];

  displayLanguageRequiredError = false;
  listBoxRequiredError = false;
  languageMaxCountError = false;
  channelBeingEdited = '';
  revalidating = false;
  timerSubscription: Subscription;

  constructor(private authorizationService: AuthorizationService, private storageManagerService: StorageManagerService, private fb: FormBuilder, private apiService: ApiCredentialsService, private toastr: ToastrService, private activatedRoute: ActivatedRoute, private appGlobals: AppGlobals, public cdref: ChangeDetectorRef, private customerService: CustomerService, private settingsService: SettingsService) { }

  ngAfterViewChecked(): void {
  }

  ngAfterContentChecked(): void {
    this.cdref.detectChanges();
  }

  @HostListener('focus', ['$event.target'])

  onFocus(target) {

  }

  ngOnInit() {

    this.loading = true;
    this.permissionsConst = this.appGlobals.permissions;
    this.serverSettings = this.settingsService.getSettings();
    this.formatOptions = { type: 'dateTime', format: 'MM/dd/yyyy hh:mm a' };
    this.listBoxSelection = {
      showCheckbox: true,
      showSelectAll: true
    };
    this.listBoxFields = {
      text: 'displayValue',
      value: 'code'
    }

    this.apiSKForm = this.fb.group({
      clientId: ['', { validators: [Validators.required], updateOn: 'blur' }],
      clientPassword: ['', { validators: [Validators.required], updateOn: 'blur' }],
      comparePassword: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });

    this.apiEUDForm = this.fb.group({
      srn: ['', { validators: [Validators.required, Validators.pattern(this.srnPattern)], updateOn: 'blur' }],
      accessToken: ['', { validators: [Validators.required], updateOn: 'blur' }],
      compareAccessToken: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });

    this.apiAUForm = this.fb.group({
      tbsid: ['', { validators: [Validators.required, Validators.maxLength(250)], updateOn: 'blur' }],
      subscriptionKey: ['', { validators: [Validators.required, Validators.maxLength(250)], updateOn: 'blur' }],
      compareSubscriptionKey: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });

    this.apiSWForm = this.fb.group({
      chrn: ['', { validators: [Validators.required, Validators.maxLength(250)], updateOn: 'blur' }],
      swClientId: ['', { validators: [Validators.required, Validators.maxLength(250)], updateOn: 'blur' }],
      swClientSecret: ['', { validators: [Validators.required, Validators.maxLength(250)], updateOn: 'blur' }],
      compareSwClientSecret: ['', { validators: [Validators.required], updateOn: 'blur' }]
    });

    this.dataScopeEnum = DataScopesEnum;

    const cust = this.storageManagerService.read('currentCustomer');
    this.dataScope = this.storageManagerService.read('dataScope');

    this.timerInterval = this.serverSettings.hasOwnProperty('APIPollTimeIntervalInMillSeconds') ?
      +this.serverSettings.APIPollTimeIntervalInMillSeconds : 5000;

    if (cust) {
      this.customer = typeof cust === 'object' ? cust : JSON.parse(cust);
      this.applicationVariants = this.customer.applicationVariants;
    }

    this.clientAdminTabEnabled = this.authorizationService.hasPermissionPerClient(this.appGlobals.permissions.CanAccessClientAdminSettings);

    if (this.clientAdminTabEnabled) {
      this.subscription = this.apiService.getApiCredentials(this.customer).subscribe(data => {

        this.apiData = data;
        this.clientData = (this.apiData as IApiCredentials).data;

        this.accessPermissions = this.storageManagerService.read('accessPermissions');

        if (this.accessPermissions && this.accessPermissions.length) {
          this.permissionsPerClient = this.authorizationService.permissionsToStringObject(this.accessPermissions);
        }

        this.loading = false;

        this.subscription = this.apiSKForm.valueChanges.subscribe(data => {
          this.comparePasswords(data);
          this.logValidationErrors(this.apiSKForm);
        });

        this.subscription = this.apiEUDForm.valueChanges.subscribe(data => {
          this.compareAccessTokens(data);
          this.logValidationErrors(this.apiEUDForm);
        });

        this.subscription = this.apiAUForm.valueChanges.subscribe(data => {
          this.comparesubScriptionKeys(data);
          this.logValidationErrors(this.apiAUForm);
        });

        this.subscription = this.apiSWForm.valueChanges.subscribe(data => {
          this.compareSwClientSecrets(data);
          this.logValidationErrors(this.apiSWForm);
        });
      })
    }

    this.resolverData = this.activatedRoute.snapshot.data['api'];

    if (this.resolverData) {

      // getting isLanguageEnabled for the client from the resolver.
      this.clientLanguageSupportEnabled = this.resolverData[2];

      if (this.clientLanguageSupportEnabled) {

        // so the client is enabled for Language support. Can the user modify it now? Is there a permission?
        this.languageAdminPermission = this.authorizationService.hasPermissionPerClient(this.appGlobals.permissions.CanEditLanguageSettings);

        // the call is made only if the a User is the Language Admin and the Client's Language Support is enabled
        this.languageTabEnabled = this.languageAdminPermission && this.clientLanguageSupportEnabled;

        if (this.languageTabEnabled) {

          // both criterias are met. The Client is enabled for Language Support and the user has a permission.
          this.languageData = this.resolverData[0];

          // the whole settings structure including client enabled/disabled and supported languages
          this.appConfigObject = this.languageData['data'];

          // time to get the system languages
          this.systemLanguages = this.resolverData[1];

          // and create a datastory for the Listbox
          if (this.systemLanguages && this.systemLanguages.length) {
            this.createListBoxDataStore(this.systemLanguages);
          }

          // sorted array is for the display
          this.prepareClientLanguageSupportObject(this.appConfigObject.languageSupport);

          // start the Timer to scheck if the language change revalidation is going on
          if (this.clientLanguageSupportEnabled && this.dataScope) {

            // call the Timer to check if the re-validation is in progress
            this.timerSubscription = timer(0, this.timerInterval).subscribe(() =>
              this.revalidationCheck(this.dataScope));
          }
        }
      }
    }

    this.setInitialActiveTab();

    // set focus on the invisible div so the first tab will bring it to the "Skip to Main Navigation" button because it must be the first tab target on the page (508 Compliance)
    this.initTabIndex();
  }

  private setInitialActiveTab(): void {

    const enabledTabs: string[] = [];
    const activeTabFromStorage = this.storageManagerService.read('languagePageActiveTab');

    if (this.clientAdminTabEnabled) {
      enabledTabs.push('clientAdmin');
    }

    if (this.languageTabEnabled) {
      enabledTabs.push('languageAdmin');
    }

    if (enabledTabs.length) {
      this.activeTab = enabledTabs.includes(activeTabFromStorage) ? activeTabFromStorage : enabledTabs[0];
    }

    if (this.tabset) {
      this.tabset.activeId = this.activeTab;
    }
  }

  displayLink(channel) {

    return !((channel.toLowerCase() === this.dataScope?.toLowerCase()) && this.revalidating)
  }

  revalidationCheck(dataScope) {

    // Make the service call only if the Client is enabled for the language support.
    if (this.clientLanguageSupportEnabled && this.dataScope) {
      this.subscription = this.customerService.getMigrationStatus(dataScope).subscribe((response: ILanguageApiResponse) => {

        if (response.data) {
          this.revalidating = response.data.isMigrating
        }
      })
    }
  }

  private prepareClientLanguageSupportObject(objectToCopy: ILanguageSupport[]) {

    // if subscribed application variants has channels than saved settings does not - we add a block for the missing Channel
    this.applicationVariants.forEach(appVar => {

      if (this.appConfigObject.languageSupport.findIndex(x => x.channel.toLowerCase() === appVar.applicationVariantName.toLowerCase()) === -1) {

        const langSupport = <ILanguageSupport>{};

        langSupport.enabled = false;
        langSupport.channel = appVar.applicationVariantName;
        langSupport.displayLanguage = {
          languageCode: '',
          languageValue: ''
        };
        langSupport.modifyDateTime = '';
        langSupport.modifyUser = '';
        langSupport.supportedLanguages = [];

        this.appConfigObject.languageSupport.push(langSupport);
      }
    });

    // sort array by a channel name and ajust to the application variant ids of the Client
    this.sortArray(objectToCopy, 'channel');

    // creating a deep copy for further data manipulation
    this.sortedClientLanguageDataNames = [...objectToCopy];

    if (this.sortedClientLanguageDataNames && this.sortedClientLanguageDataNames.length) {
      this.sortedClientLanguageDataNames.forEach(channel => {

        let channelLanguages = channel.supportedLanguages;

        // sort languageValues inside the channel
        if (channelLanguages && channelLanguages.length) {
          channelLanguages = this.sortArray(channelLanguages, 'languageValue');
        }
      });
    }
  }

  createListBoxDataStore(languagesArray) {
    // create a dataStore for the ListBox
    if (languagesArray && languagesArray.length) {

      // initialize the datastore array
      this.languagesListBoxDS = [];

      languagesArray.forEach((item) => {

        if (item.termValueDescription.toLowerCase() !== 'any') {
          this.languagesListBoxDS.push({
            code: `${item.termValueCode}`,
            language: `${item.termValueDescription}`,
            displayValue: `${item.termValueDescription} (${item.termValueCode})`
          })
        } else {
          this.languagesListBoxDS.push({
            code: `${item.termValueDescription.toUpperCase()}`,
            language: `${item.termValueDescription.toUpperCase()}`,
            displayValue: `${item.termValueDescription.toUpperCase()}`
          })
        }
      });

      // sort languages in the ListBox datastore
      this.languagesListBoxDS = this.sortArray(this.languagesListBoxDS, 'language');
    }
  }

  ngAfterViewInit(): void {
  }

  initTabIndex() {
    (document.activeElement as HTMLElement).blur();

    const main = document.getElementById('firstDiv');

    if (main) {
      main.focus();
    }
  }

  setPasswordFields() {

    const element = document.getElementsByName('clientPassword')[0];

    if (element) {
      if (element.getAttribute('type') === 'text' || element.innerText) {
        element.setAttribute('type', 'password');
      }
    }
  }


  addLinkClicked(appVar) {

    switch (appVar) {
      case this.dataScopeEnum.EUDAMED:
        this.showEUDForm = true;
        break;

      case this.dataScopeEnum.SKOREA:
        this.showSKForm = true;
        break;

      case this.dataScopeEnum.AU:
        this.showAUForm = true;
        break;

      case this.dataScopeEnum.SWISSDAMED:
        this.showSWForm = true;
        break;
    }

    this.showLink = false;
  }

  showAddLink(appVar): boolean {

    const apiData = (this.clientData as any).filter(d => d['applicationVariantName'] === appVar.toLowerCase());

    if (this.hasApiAccess(appVar) && !apiData) {
      return true;
    }

    return false;
  }

  getHA(appVar): IApiCredentials | null {

    const apiData = (this.clientData as any)?.filter(d => d['applicationVariantName'] === appVar.applicationVariantName.toLowerCase());

    if (apiData && apiData.length) {
      if (this.hasApiAccess(appVar.applicationVariantName)) {
        this.showLink = true;
      }

      return apiData;
    }

    return null;
  }

  haDisplayedText(ha) {

    let retVal;

    if (this.clientData && (this.clientData as any).length) {
      this.apiData = (this.clientData as any).filter(d => d['applicationVariantName'] === ha.toLowerCase());
    }

    if (this.apiData && (this.apiData as any).length && this.apiData[0].credentialIds && this.apiData[0].credentialIds.length) {

      this.apiData[0].credentialIds.forEach((credential, i) => {

        switch (ha) {
          case this.dataScopeEnum.SKOREA:
            retVal = `Delete South Korea API Credentials - Client ID: `;
            break;
          case this.dataScopeEnum.EUDAMED:
            retVal = `Delete SRN: `;
            break;
          case this.dataScopeEnum.AU:
            retVal = `Delete TBS ID: `;
            break;
          case this.dataScopeEnum.SWISSDAMED:
            retVal = `Delete CHRN: `;
            break;
        }
      });

    } else {
      // if credentials don't exist set an option to Add
      this.showLink = true;

      switch (ha) {
        case this.dataScopeEnum.SKOREA:
          retVal = 'Add South Korea Credentials';
          break;
        case this.dataScopeEnum.EUDAMED:
          retVal = 'Add SRN and Access Token';
          break;
        case this.dataScopeEnum.AU:
          retVal = 'Add TGA Business Services (TBS) ID and API Subscription Key';
          break;
        case this.dataScopeEnum.SWISSDAMED:
          retVal = 'Add CHRN and API Credentials';
          break;
      }
    }

    return retVal;
  }

  getIconClass(ha, id?: string): string {

    let retVal;

    // If client id exists for SKorea - show the "delete" icon.
    // For the Eudamed we don't have delete functionality currently. Display no icon.
    switch (ha) {
      case this.dataScopeEnum.SKOREA:
        retVal = id ? 'fa fa-minus-circle' : 'fa fa-plus-circle';
        break;
      case this.dataScopeEnum.EUDAMED:
        retVal = '';
        break;
      case this.dataScopeEnum.AU:
        retVal = '';
        break;
      case this.dataScopeEnum.SWISSDAMED:
        retVal = '';
        break;
    }

    return retVal;
  }

  hasApiAccess(ha) {

    if (this.accessPermissions) {

      return this.accessPermissions.findIndex(i => i.permissionName === this.permissionsConst.CanUpdateApiCredentials && i.applicationVariantName.toLowerCase() === ha.toLowerCase()) >= 0;
    }

    return false;
  }

  anyHAhasPermission(): boolean {

    if (this.accessPermissions && this.accessPermissions.length) {

      return this.accessPermissions.filter(i => i.permissionName === this.permissionsConst.CanUpdateApiCredentials)?.length >= 0;
    }

    return false;
  }

  linkClicked(ha, id?: string) {

    // currently Eudamed doesn't have delete functionality
    switch (ha) {
      case this.dataScopeEnum.EUDAMED:
      case this.dataScopeEnum.SKOREA:

        if (id) {
          this.deleteLinkClicked(ha, id);
        } else {
          // if showLink is false, the form is displayed. Clear the fields
          this.clearForm();
          this.showLink = false;
          this.showSKForm = true;
        }
        break;
      case this.dataScopeEnum.AU:

        if (id) {
          this.deleteLinkClicked(ha, id);
        } else {
          // if showLink is false, the form is displayed. Clear the fields
          this.clearForm();
          this.showLink = false;
          this.showAUForm = true;
        }
        break;

      case this.dataScopeEnum.SWISSDAMED:

        if (id) {
          this.deleteLinkClicked(ha, id);
        } else {
          // if showLink is false, the form is displayed. Clear the fields
          this.clearForm();
          this.showLink = false;
          this.showSWForm = true;
        }
        break;
    }
  }

  deleteLinkClicked(appVar, id) {

    this.toDelete = Object.assign({});

    this.toDelete.appVarName = appVar;
    this.toDelete.id = id;
    this.confirmDialog.show();
  }

  deleteApiCredentials() {

    this.loading = true;
    this.saving = true;

    this.subscription = this.apiService.deleteApiCredentials(this.toDelete.id, this.toDelete.appVarName).subscribe(result => {

      if (result['isSuccess']) {
        this.showLink = true;
        this.showSKForm = false;
        this.showEUDForm = false;
        this.toastr.success('Api Credentials have been removed.');
        this.reloadData();
      } else {
        this.toastr.error('Internal error during removal of the Api Credentials');
      }

      this.loading = false;
      this.saving = false;
    });
  }

  canDeactivate() {

    if (this.apiEUDForm.touched && !this.formSaved) {
      return confirm(`Are you sure you want to navigate away and discard your changes?`);
    }

    if (this.apiSKForm.touched && !this.formSaved) {
      return confirm(`Are you sure you want to navigate away and discard your changes?`);
    }

    if (this.apiAUForm.touched && !this.formSaved) {
      return confirm(`Are you sure you want to navigate away and discard your changes?`);
    }

    if (this.apiSWForm.touched && !this.formSaved) {
      return confirm(`Are you sure you want to navigate away and discard your changes?`);
    }

    return true;
  }

  comparePasswords(data) {

    if (this.apiSKForm.controls.comparePassword.touched || this.apiSKForm.controls.comparePassword.dirty) {

      const pass = data.clientPassword;
      const confirmPass = data.comparePassword;

      this.isMatch = pass === confirmPass;
    }
  }

  compareAccessTokens(data) {

    if (this.apiEUDForm.controls.compareAccessToken.touched || this.apiEUDForm.controls.compareAccessToken.dirty) {

      const pass = data.accessToken;
      const confirmPass = data.compareAccessToken;

      this.isMatch = pass === confirmPass;
    }
  }

  comparesubScriptionKeys(data) {

    if (this.apiAUForm.controls.compareSubscriptionKey.touched || this.apiAUForm.controls.compareSubscriptionKey.dirty) {

      const pass = data.subscriptionKey;
      const confirmPass = data.compareSubscriptionKey;

      this.isMatch = pass === confirmPass;
    }
  }

  compareSwClientSecrets(data) {

    if (this.apiSWForm.controls.compareSwClientSecret.touched || this.apiSWForm.controls.compareSwClientSecret.dirty) {

      const pass = data.swClientSecret;
      const confirmPass = data.compareSwClientSecret;

      this.isMatch = pass === confirmPass;
    }
  }

  changeInputType(field) {

    const element = document.getElementsByName(field)[0];

    if (element) {
      if (element.getAttribute('type') === 'text') {
        element.setAttribute('type', 'password');
      }
    }
  }

  onKeyUp(e, formName) {

    let form: FormGroup;

    switch (formName.toLowerCase()) {
      case this.dataScopeEnum.SKOREA.toLowerCase():

        form = this.apiSKForm;
        break;

      case this.dataScopeEnum.EUDAMED.toLowerCase():

        form = this.apiEUDForm;
        break;

      case this.dataScopeEnum.AU.toLowerCase():

        form = this.apiAUForm;
        break;

      case this.dataScopeEnum.SWISSDAMED.toLowerCase():

        form = this.apiSWForm;
        break;
    }
    this.logValidationErrors(form);
    this.isMatch = true;
  }

  clearFieldErrors(field) {
    this.formErrors[field] = '';
  }

  cancelForm() {
    this.clearForm();
    this.showLink = true;
    this.loading = false;
    this.isMatch = true;
    this.showSKForm = false;
    this.showEUDForm = false;
    this.showAUForm = false;
    this.showSWForm = false;
  }

  get apiSKFormControls() {
    return this.apiSKForm.controls;
  }

  get apiEUDFormControls() {
    return this.apiEUDForm.controls;
  }
  get apiAUFormControls() {
    return this.apiAUForm.controls;
  }

  get apiSWFormControls() {
    return this.apiSWForm.controls;
  }
  reloadData() {

    this.apiService.getApiCredentials(this.customer).subscribe(data => {
      this.apiData = data;
      this.clientData = (this.apiData as IApiCredentials).data;
      this.loading = false;
    });
  }

  saveSKForm() {

    this.setFormErrors(this.dataScopeEnum.SKOREA);

    if (this.apiSKForm.valid && this.isMatch) {

      this.saving = true;
      this.formSaved = true;
      this.loading = true;

      const apiCredentials = {
        'credentialId': this.apiSKForm.value.clientId,
        'credentialSecret': this.apiSKForm.value.clientPassword
      };

      this.subscription = this.apiService.saveApiCredentials(apiCredentials, this.dataScopeEnum.SKOREA).subscribe(res => {

        if (res['isSuccess']) {
          this.showLink = true;
          this.showSKForm = false;
          this.displayedText = `Delete South Korea API Credentials - Client ID: `;

          this.clearForm();
          this.toastr.success('Api Credentials saved successfully', '', { closeButton: true });
          this.reloadData();
          this.saving = false;
        } else {

          this.displayedText = 'Add South Korea Credentials';
          this.loading = false;
          this.saving = false;
        }
      });
    }
  }

  saveEUDForm() {

    this.setFormErrors(this.dataScopeEnum.EUDAMED);

    if (this.apiEUDForm.valid && this.isMatch) {

      this.saving = true;

      this.duplicateSNR = this.isDuplicate(this.apiEUDForm.value.srn);

      if (!this.duplicateSNR) {

        this.formErrors.srn = '';
        this.formSaved = true;
        this.loading = true;

        const apiCredentials = {
          'credentialId': this.apiEUDForm.value.srn,
          'credentialSecret': this.apiEUDForm.value.accessToken
        };

        this.subscription = this.apiService.saveApiCredentials(apiCredentials, this.dataScopeEnum.EUDAMED).subscribe(res => {

          if (res['isSuccess']) {
            this.showLink = true;
            this.showEUDForm = false;
            this.clearForm();
            this.toastr.success('Api Credentials saved successfully', '', { closeButton: true });

            this.reloadData();
            this.saving = false;
          }
        });
      } else {
        this.formErrors.srn = this.validationMessages.srn.duplicate;
        this.saving = false;
      }
    }
  }

  saveAUForm() {

    this.setFormErrors(this.dataScopeEnum.AU);

    if (this.apiAUForm.valid && this.isMatch) {

      this.saving = true;

      this.duplicateTBSID = this.isDuplicate(this.apiAUForm.value.tbsid, this.dataScopeEnum.AU);

      if (!this.duplicateTBSID) {

        this.formErrors.tbsid = '';
        this.formSaved = true;
        this.loading = true;

        const apiCredentials = {
          'credentialId': this.apiAUForm.value.tbsid,
          'credentialSecret': this.apiAUForm.value.subscriptionKey
        };

        this.subscription = this.apiService.saveApiCredentials(apiCredentials, this.dataScopeEnum.AU).subscribe(res => {

          if (res['isSuccess']) {
            this.showLink = true;
            this.showAUForm = false;
            this.clearForm();
            this.toastr.success('Api Credentials saved successfully', '', { closeButton: true });

            this.reloadData();
            this.saving = false;
          }
        });
      } else {
        this.formErrors.tbsid = this.validationMessages.tbsid.duplicate;
        this.saving = false;
      }
    }
  }

  saveSWForm() {

    this.setFormErrors(this.dataScopeEnum.SWISSDAMED);

    if (this.apiSWForm.valid && this.isMatch) {

      this.saving = true;

      this.duplicateCHRN = this.isDuplicate(this.apiSWForm.value.chrn, this.dataScopeEnum.SWISSDAMED);

      if (!this.duplicateCHRN) {

        this.formErrors.chrn = '';
        this.formSaved = true;
        this.loading = true;

        const apiCredentials = {
          'credentialId': this.apiSWForm.value.chrn,
          'clientId': this.apiSWForm.value.swClientId,
          'credentialSecret': this.apiSWForm.value.swClientSecret
        };

        this.subscription = this.apiService.saveApiCredentials(apiCredentials, this.dataScopeEnum.SWISSDAMED).subscribe(res => {

          if (res['isSuccess']) {
            this.showLink = true;
            this.showSWForm = false;
            this.clearForm();
            this.toastr.success('Api Credentials saved successfully', '', { closeButton: true });

            this.reloadData();
            this.saving = false;
          }
        });
      } else {
        this.formErrors.chrn = this.validationMessages.chrn.duplicate;
        this.saving = false;
      }
    }
  }
  isDuplicate(srn: string, healthAuthority: string = this.dataScopeEnum.EUDAMED): boolean {

    let retVal;
    let exists;
    let credentials;

    if (this.clientData) {
      const eudData = (this.clientData as any).filter(d => d['applicationVariantName'] === healthAuthority.toLowerCase());

      if (eudData && eudData.length) {

        credentials = eudData[0].credentialIds;
      }

      if (credentials && credentials.length) {

        credentials.map(item => item)
          .filter((value, index, self) => self.indexOf(value) === index);

        for (let i = 0; i < credentials.length; i++) {
          exists = credentials.filter(
            c => c === srn
          )[0];
        }
      }
    }

    retVal = !!exists;

    return retVal;
  }


  clearForm() {
    this.apiSKForm.reset();
    this.apiEUDForm.reset();
    this.apiAUForm.reset();
    this.apiSWForm.reset();
    this.loading = false;
  }

  setFormErrors(appVar) {

    switch (appVar) {
      case this.dataScopeEnum.SKOREA:
        if (!this.apiSKForm.value.clientId) {

          this.formErrors.clientId = this.validationMessages.clientId.required;
        }

        if (!this.apiSKForm.value.clientPassword) {

          this.formErrors.clientPassword = this.validationMessages.clientPassword.required;
        }

        if (!this.apiSKForm.value.comparePassword) {

          this.formErrors.comparePassword = this.validationMessages.comparePassword.required;
        }
        break;

      case this.dataScopeEnum.EUDAMED:
        if (!this.apiEUDForm.value.srn) {

          this.formErrors.srn = this.validationMessages.srn.required;
        } else {
          if (!this.apiEUDForm.value.srn.pattern) {

            this.formErrors.srn = this.validationMessages.srn.pattern;
          }
        }

        if (!this.apiEUDForm.value.accessToken) {

          this.formErrors.accessToken = this.validationMessages.accessToken.required;
        }

        if (!this.apiEUDForm.value.compareAccessToken) {

          this.formErrors.compareAccessToken = this.validationMessages.compareAccessToken.required;
        }
        break;

      case this.dataScopeEnum.AU:
        if (!this.apiAUForm.value.tbsid) {

          this.formErrors.tbsid = this.validationMessages.tbsid.required;
        }

        if (!this.apiAUForm.value.subscriptionKey) {

          this.formErrors.subscriptionKey = this.validationMessages.subscriptionKey.required;
        }

        if (!this.apiAUForm.value.compareSubscriptionKey) {

          this.formErrors.compareSubscriptionKey = this.validationMessages.compareSubscriptionKey.required;
        }
        break;

      case this.dataScopeEnum.SWISSDAMED:
        if (!this.apiSWForm.value.chrn) {

          this.formErrors.chrn = this.validationMessages.chrn.required;
        }

        if (!this.apiSWForm.value.swClientId) {

          this.formErrors.swClientId = this.validationMessages.swClientId.required;
        }

        if (!this.apiSWForm.value.swClientSecret) {

          this.formErrors.swClientSecret = this.validationMessages.swClientSecret.required;
        }

        if (!this.apiSWForm.value.compareSwClientSecret) {

          this.formErrors.compareSwClientSecret = this.validationMessages.compareSwClientSecret.required;
        }
        break;
    }

    this.loading = false;
  }


  /**
   * The function drills to down from the FormGroup or FormArray down
   * to the AbstractControl in order to check if the value is entered.
   * Populates the FormErrors object based on the Validators attached to the formControls.
   * @param {FormGroup} group passed by the form validation.
   */
  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);

      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid
        && (abstractControl.touched || abstractControl.dirty)
      ) {
        const messages = this.validationMessages[key];

        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      }

      // We need this additional check to get to the FormGroup
      // in the FormArray and then recursively call this
      // logValidationErrors() method to fix the broken validation
      if (abstractControl instanceof FormArray) {
        for (const control of abstractControl.controls) {
          if (control instanceof FormGroup) {
            this.logValidationErrors(control);
          }
        }
      }
    });
  }

  srnOnBlur(event) {

    const srn = event.target.value;

    if (this.isDuplicate(srn)) {
      this.formErrors.srn = this.validationMessages.srn.duplicate;
    }
  }

  viewPassword(elementName) {

    // get the field
    const element = document.getElementsByName(elementName)[0];

    // get the icon
    const passStatus = document.getElementById('pass-status');

    if ((element as any).type === 'password') {
      (element as any).type = 'text';
      (passStatus as any).className = 'fal fa-eye-slash';
    } else {
      (element as any).type = 'password';
      (passStatus as any).className = 'fal fa-eye';
    }
  }



  viewPasswordCompare(elementName) {
    const element = document.getElementsByName(elementName)[0];
    const passStatus = document.getElementById('pass-status-compare');

    if ((element as any).type === 'password') {
      (element as any).type = 'text';
      (passStatus as any).className = 'fal fa-eye-slash';
    } else {
      (element as any).type = 'password';
      (passStatus as any).className = 'fal fa-eye';
    }
  }

  onKeyUpAccessToken(event) {

    if (event.target.value) {
      this.showEyeIcon = true;
    } else {
      this.showEyeIcon = false;
    }
  }

  onKeyUpAccessTokenCompare(event) {

    if (event.target.value) {
      this.showEyeIconCompare = true;
    } else {
      this.showEyeIconCompare = false;
    }
  }

  get eudaForm() {
    return this.apiEUDForm.controls;
  }

  get skForm() {
    return this.apiSKForm.controls;
  }
  get auForm() {
    return this.apiAUForm.controls;
  }
  get swissForm() {
    return this.apiSWForm.controls;
  }

  // language support
  tabChanged(event) {

    this.tabset.activeId = event.nextId;
    this.storageManagerService.write('languagePageActiveTab', event.nextId);
  }

  joinFieldArray(data, field): string {

    let retVal;

    const fieldArray = data[field];

    if (fieldArray && fieldArray.length) {
      retVal = fieldArray.map((elem) => {
        return elem.languageValue;
      })?.join(', ');
    }

    return retVal;
  }

  sortArray(array, property) {

    let retVal = array?.sort((a, b) => a[property].localeCompare(b[property]))

    return retVal;
  }

  editChannelLanguages(data) {

    this.displayEditScreen = true;
    this.channelBeingEdited = data.channel;
    this.channelLanguageEnabled = data.enabled;
    this.selectedDisplayLanguageCode = data.displayLanguage.languageValue?.toUpperCase();

    this.setValidationErrors(false);

    this.channelLanguageSupport = data;

    this.formModified = false;

    if (data.channel.toLowerCase() === this.dataScopeEnum.EUDAMED.toLowerCase()) {
      this.apiService.getSystemLanguages(this.eudamedLanguagesCategory).subscribe(data => {

        if (data && data.length) {
          this.createListBoxDataStore(data);
        }
      })
    } else if (data.channel.toLowerCase() === this.dataScopeEnum.SWISSDAMED.toLowerCase()) {
      this.apiService.getSystemLanguages(this.swissdamedLanguagesCategory).subscribe(data => {

        if (data && data.length) {
          this.createListBoxDataStore(data);
        }
      })
    } else {
      this.createListBoxDataStore(this.systemLanguages);
    }
  }

  checkChanged(channelToCheck) {

    // compare with the original object
    const originalChannel = this.sortedClientLanguageDataNames.find(x => x.channel === channelToCheck.channel);

    // enabled property
    if (originalChannel.enabled !== this.channelLanguageEnabled) {
      return true;
    }

    // display language
    if (!channelToCheck.enabled) {
      this.selectedDisplayLanguageCode = '';
      this.selectedLanguagesArray = [];
    } else

      if (originalChannel.displayLanguage?.languageCode?.toLowerCase() !== this.selectedDisplayLanguageCode?.toLowerCase()) {
        return true;
      }

    // if the length of the supported languages array is not the same - something modified
    if (originalChannel.supportedLanguages.length !== this.selectedLanguagesArray.length) {
      return true;
    } else {

      let modifiedLang = 0;

      // if the length is the same check if the lenght is greater than 0 and compare
      if (originalChannel.supportedLanguages.length) {

        originalChannel.supportedLanguages.forEach(element => {

          if (this.selectedLanguagesArray.findIndex(x => x.code.toLowerCase() === element.languageCode.toLowerCase()) === -1) {
            modifiedLang++;
          }
        });
      }

      return modifiedLang > 0;
    }
  }

  saveLanguageEdit(save: boolean) {

    // update the Client object that will be sent for Saving
    const channelIndex = this.sortedClientLanguageDataNames.findIndex(x => x.channel.toLowerCase() === this.channelLanguageSupport.channel.toLowerCase());

    const channelToCheck = this.sortedClientLanguageDataNames.find(x => x.channel.toLowerCase() === this.channelLanguageSupport.channel.toLowerCase());

    const changed = this.checkChanged(channelToCheck);

    if (!changed) {
      this.modalDialog.show();
    }

    // validate required fields
    const errorsFound = changed ? this.validateLanguageEdit() : false;

    if (changed && !errorsFound) {

      this.confirmDialog.show();

      // if a "save" parameter is true do save
      if (save) {

        this.saving = true;

        if (this.channelLanguageSupport) {

          // update Channel-Language object
          this.channelLanguageSupport.enabled = this.channelLanguageEnabled;

          // update the Client object that will be sent for Saving
          const channelIndex = this.sortedClientLanguageDataNames.findIndex(x => x.channel.toLowerCase() === this.channelLanguageSupport.channel.toLowerCase());

          // update the property value on the original array
          this.sortedClientLanguageDataNames[channelIndex].enabled = this.channelLanguageSupport.enabled;
        }

        // set selected values on the object. First the selected languages from the List Box
        if (this.selectedLanguagesArray && this.selectedLanguagesArray.length) {

          // update the Client object that will be sent for Saving
          const channelIndex = this.sortedClientLanguageDataNames.findIndex(x => x.channel.toLowerCase() === this.channelLanguageSupport.channel.toLowerCase());

          // update the property value on the original array
          const selectedLangs: ILanguage[] = [];

          this.selectedLanguagesArray.forEach(element => {
            selectedLangs.push(
              {
                languageValue: element['language'],
                languageCode: element['code'].toLowerCase()
              })
          });

          // find a description of the language code of the Display Language
          const languageValue = this.systemLanguages.find(x => x.termValueCode.toLowerCase() === this.selectedDisplayLanguageCode.toLowerCase())?.termValueDescription;

          // update the property value on the original array
          this.sortedClientLanguageDataNames[channelIndex].displayLanguage = { languageValue: languageValue, languageCode: this.selectedDisplayLanguageCode.toLowerCase() };

          this.sortedClientLanguageDataNames[channelIndex].supportedLanguages = selectedLangs;
        } else {
          this.sortedClientLanguageDataNames[channelIndex].supportedLanguages = [];
          this.sortedClientLanguageDataNames[channelIndex].displayLanguage = {
            languageValue: '',
            languageCode: ''
          }
        }

        const languageSettings = {
          languageSupport: this.sortedClientLanguageDataNames
        };


        this.subscription = this.apiService.saveChannelLanguageConfig(languageSettings).subscribe((response: IApplicationSettings) => {

          if (response.isSuccess) {
            this.toastr.success('Your request has been processed.');

            if (response.data && response.data.languageSupport && response.data.languageSupport.length) {
              this.sortedClientLanguageDataNames = response.data.languageSupport;
              this.prepareClientLanguageSupportObject(this.sortedClientLanguageDataNames);
            }
          } else {
            this.toastr.error(response.message);
          }
          this.saving = false;
          this.displayEditScreen = false;
          this.formModified = false;
        });
      }
    }
  }

  validateLanguageEdit(): boolean {

    if (this.channelLanguageEnabled) {

      // check if Display Language provided
      if (this.selectedLanguagesArray.length && !this.selectedDisplayLanguageCode) {
        this.displayLanguageRequiredError = true;
      }

      if (!this.selectedLanguagesArray.length) {
        this.listBoxRequiredError = true;
        this.displayLanguageRequiredError = true;
      } else {
        this.checkMaxCountOfAllowedLanguages();
      }

      return this.displayLanguageRequiredError || this.listBoxRequiredError || this.languageMaxCountError;
    }

    return false;
  }

  checkMaxCountOfAllowedLanguages() {
    const channel = this.channelBeingEdited?.toLowerCase();
    const editedChannel = (channel === this.dataScopeEnum.EUDAMED.toLowerCase() || channel === this.dataScopeEnum.SWISSDAMED.toLowerCase())
      ? channel : 'default';

    const isUnlimitedLanguage =
      editedChannel === this.dataScopeEnum.EUDAMED.toLowerCase() || editedChannel === this.dataScopeEnum.SWISSDAMED?.toLowerCase();

    // check that the numbers of selected languages not exceed the allowed maximum
    // If the channel is EUDAMED or SWISSDAMED, there is no limitation on the max count for languages
    if (isUnlimitedLanguage) {
      this.languageMaxCountError = false;
      return;
    }

    // For all other channels, check the max count
    if (this.appConfigObject.maximumNumberOfLanguagesForHA && this.appConfigObject.maximumNumberOfLanguagesForHA.length) {

      const maxCount = this.appConfigObject.maximumNumberOfLanguagesForHA.find(x => x.channel.toLowerCase() === editedChannel)?.maxCount;

      this.languageMaxCountError = this.selectedLanguagesArray.length > (maxCount ? maxCount : 1);
    }
  }

  setValidationErrors(flag) {
    this.displayLanguageRequiredError = flag;
    this.listBoxRequiredError = flag;
    this.languageMaxCountError = flag;
  }

  validationErrors() {
    return this.displayLanguageRequiredError || this.listBoxRequiredError || this.languageMaxCountError;
  }

  cancelLanguageEdit() {

    this.channelBeingEdited = '';
    this.selectedDisplayLanguageCode = '';
    this.selectedLanguagesArray = [];

    this.displayEditScreen = false;
    this.formModified = false;
    this.setValidationErrors(false);
  }

  toggleChannelEnableLanguageMode(event) {

    this.formModified = true;
    this.channelLanguageEnabled = event.checked;

    if (this.selectedLanguagesArray && this.selectedLanguagesArray.length) {

      const listboxobj: ListBox = getInstance(document.getElementById('listbox'), ListBox) as ListBox;

      this.selectedLanguagesArray.forEach(element => {
        listboxobj.selectItems([element['displayValue']], this.channelLanguageEnabled);
      });
    }

    if (!this.channelLanguageEnabled) {
      this.selectedLanguagesArray = [];
      this.selectedDisplayLanguageCode = '';
    }

    this.listBoxRequiredError = false;
    this.displayLanguageRequiredError = false;
  }

  listBoxCreated() {
    this.selectedLanguagesArray = [];

    // get the listbox instance
    const listboxobj: ListBox = getInstance(document.getElementById('listbox'), ListBox) as ListBox;

    this.languagesListBoxDS.forEach(element => {
      // find the languages that had been previously selected for the channel
      if (this.channelLanguageSupport && this.channelLanguageSupport.supportedLanguages.length) {
        // select the language in the list
        if (this.channelLanguageSupport.supportedLanguages.findIndex(x => x.languageCode?.toLowerCase() === element.code.toLowerCase()) > -1) {
          listboxobj.selectItems([element['displayValue']]);
        }
      }
    });

    this.selectedDisplayLanguageCode = this.channelLanguageSupport.displayLanguage.languageCode.toUpperCase();
  }

  listboxSelectionChanged(event) {

    this.formModified = true;
    this.selectedLanguagesArray = [];
    // Get the listbox instance to get ALL selected values (not just the delta from event)
    const listboxobj = getInstance(document.getElementById('listbox'), ListBox) as ListBox;

    // Get all currently selected values from the listbox
    const allSelectedValues = listboxobj.value as string[];

    // Map all selected values to full objects with proper copies
    if (allSelectedValues?.length > 0) {
      this.selectedLanguagesArray = this.languagesListBoxDS.filter(item =>
        allSelectedValues.includes(item.code)
      ).map(item => ({
        code: item.code,
        language: item.language,
        displayValue: `${item.language} (${item.code})`
      }));
    }

    const previouslySavedDisplayLanguage = this.sortedClientLanguageDataNames.find(x => x.channel.toLowerCase() === this.channelBeingEdited.toLowerCase())?.displayLanguage?.languageCode;

    const displayedLanguageExistsInDdw = this.selectedLanguagesArray.findIndex(x => x.code.toLowerCase() === previouslySavedDisplayLanguage.toLowerCase()) >= 0;

    // set the display language
    if (!previouslySavedDisplayLanguage || this.selectedLanguagesArray.length === 1 || !displayedLanguageExistsInDdw) {
      this.selectedDisplayLanguageCode = this.selectedLanguagesArray[0]?.code;
    }

    if (this.selectedLanguagesArray.length) {
      this.listBoxRequiredError = false;

      this.checkMaxCountOfAllowedLanguages();
    } else {
      this.languageMaxCountError = false;
      this.displayLanguageRequiredError = false;
    }
  }

  displayLanguageChanged(event) {

    this.formModified = true;

    this.selectedDisplayLanguageCode = event.itemData ? event.itemData.code : '';

    if (this.selectedDisplayLanguageCode) {
      this.displayLanguageRequiredError = false;
    } else {

      if (this.selectedLanguagesArray.length) {
        this.displayLanguageRequiredError = true;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    // in this case can't reuse the subscription. Need a separate subscription for the timer
    // to be able to stop the timer on ngOnDestroy. Otherwise it keeps triggering on other pages.
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
